import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const input = "w-full rounded-xl bg-white border border-[#292522]/12 pl-11 pr-4 py-3 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm";

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Almeno 8 caratteri");
    if (password !== password2) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/accedi", { replace: true }), 2500);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Errore");
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="reset-success">
        <div className="container-vv max-w-lg text-center py-16">
          <div className="mx-auto h-16 w-16 rounded-full bg-[#DDEEE8] flex items-center justify-center mb-6">
            <CheckCircle2 className="h-8 w-8 text-[#216B65]" strokeWidth={1.75} />
          </div>
          <h1 className="font-display font-medium text-4xl">Password aggiornata</h1>
          <p className="mt-4 text-[#292522]/75">Ti stiamo reindirizzando al login…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-14" data-testid="reset-page">
      <div className="container-vv max-w-md">
        <div className="card-vv p-8 bg-white">
          <h1 className="font-display font-medium text-3xl">Nuova password</h1>
          <p className="mt-2 text-sm text-[#292522]/70">Scegli una password con almeno 8 caratteri.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-xs font-semibold text-[#292522]/70">Nuova password</span>
              <div className="relative mt-1">
                <Lock className="h-4 w-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#292522]/40" strokeWidth={1.75} />
                <input required type="password" minLength={8} className={input} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
              </div>
            </label>
            <label className="block">
              <span className="text-xs font-semibold text-[#292522]/70">Ripeti nuova password</span>
              <div className="relative mt-1">
                <Lock className="h-4 w-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#292522]/40" strokeWidth={1.75} />
                <input required type="password" minLength={8} className={input} value={password2} onChange={(e) => setPassword2(e.target.value)} data-testid="reset-password2" />
              </div>
            </label>
            <button disabled={loading} className="btn-primary w-full justify-center" data-testid="reset-submit">
              {loading ? "Salvataggio…" : "Aggiorna password"}
            </button>
            <p className="text-xs text-center text-[#292522]/60">
              <Link to="/accedi" className="text-[#FF6100]">Torna al login</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
